export const FETCH_COMPLETED_SKILLS_SUCCESS = 'FETCH_COMPLETED_SKILLS_SUCCESS';
export const FETCH_COMPLETED_SKILLS_FAILURE= 'FETCH_COMPLETED_SKILLS_FAILURE';
